<template>
    <div>
        <canvas
            ref="board"
            class="absolute-canvas"
            :width="width"
            :height="height"
        />
        <div
            v-if="signature"
            class="signature"
            :style="{ width: width + 'px', height: height + 'px' }"
        >
            <VueDragableResizable
                :w="200"
                :h="100"
                :z="40"
                :parent="true"
                :resizable="false"
                @dragstop="onDragStop"
            >
                <img :src="signature" width="200" height="100" />
            </VueDragableResizable>
        </div>
    </div>
</template>

<script>
import VueDragableResizable from "vue-draggable-resizable";
import { mapActions, mapGetters } from "vuex";

const mouseSizeX = 18;
const mouseSizeY = 18;

export default {
    name: "drawable-board",
    components: {
        VueDragableResizable,
    },
    props: {
        width: { type: Number, required: true },
        height: { type: Number, required: true },
        color: { type: String, default: "black" },
        thickness: { type: Number, default: 1 },
        signalRSocket: { type: Object, required: true },
        enabledDraw: { type: Boolean, default: false },
        index: { type: Number, default: 1 },
    },
    data() {
        return {
            board: null,
            ctx: null,
            canDraw: false,

            previousCoordinates: {},
            currentCoordinates: {},

            unsentStrokes: [],
        };
    },
    mounted() {
        let board = this.$refs.board;
        if (this.enabledDraw) {
            board.addEventListener("mousemove", this.tryDraw);
            board.addEventListener("mousedown", this.enableDraw);
            board.addEventListener("mouseup", this.disableDraw);
            board.addEventListener("mouseout", this.disableDraw);

            setInterval(this.sendStrokes, 150);
        }

        this.board = board;
        this.ctx = board.getContext("2d");

        this.signalRSocket.on("ClearBoard", this.signalRClearBoard);
        this.signalRSocket.on("SendStrokes", this.signalRNewStrokes);
    },
    beforeDestroy() {
        this.signalRSocket.off("ClearBoard", this.signalRClearBoard);
        this.signalRSocket.off("SendStrokes", this.signalRNewStrokes);
    },
    computed: {
        ...mapGetters("conference", ["getConferenceId"]),
        ...mapGetters("signature", ["getSignature"]),
        signature() {
            return this.getSignature;
        },
    },
    methods: {
        ...mapActions("signature", ["setSignatureInfo"]),
        signalRNewStrokes({ strokes }) {
            if (strokes.length) {
                strokes.forEach((s) => {
                    this.draw(s.start, s.end, s.color, s.thickness);
                });
            }
        },
        signalRClearBoard(page, all) {
            if (all) {
                this.clearBoard();
            } else {
                this.clearPage(page);
            }
        },
        sendStrokes() {
            if (this.unsentStrokes.length > 0) {
                this.signalRSocket.invoke(
                    "SendStrokes",
                    this.getConferenceId,
                    this.unsentStrokes
                );
                this.unsentStrokes = [];
            }
        },
        clearBoard() {
            this.ctx.clearRect(0, 0, this.board.width, this.board.height);
        },
        clearPage(page) {
            window.console.log(page);
            this.clearBoard();
        },
        sendClearBoard() {
            this.signalRSocket.invoke(
                "ClearBoard",
                this.getConferenceId,
                0,
                true
            );
        },
        sendClearPage(page) {
            this.signalRSocket.invoke(
                "ClearBoard",
                this.getConferenceId,
                page,
                false
            );
        },
        setCoordinates(e) {
            this.previousCoordinates = this.currentCoordinates;
            this.currentCoordinates = {
                x: e.offsetX - mouseSizeX,
                y: e.offsetY - mouseSizeY,
            };
        },
        tryDraw(e) {
            if (this.canDraw) {
                this.setCoordinates(e);
                this.draw(
                    this.previousCoordinates,
                    this.currentCoordinates,
                    this.color,
                    this.thickness
                );
                this.storeStroke(
                    this.previousCoordinates,
                    this.currentCoordinates,
                    this.color,
                    this.thickness
                );
            }
        },
        draw(start, end, color, thickness) {
            this.ctx.beginPath();

            this.ctx.strokeStyle = color;
            this.ctx.lineWidth = thickness;
            this.ctx.lineCap = "round";

            let prevX = start.x;
            let prevY = start.y;
            this.ctx.moveTo(prevX, prevY);

            let x = end.x;
            let y = end.y;
            this.ctx.lineTo(x, y);

            this.ctx.stroke();
            this.ctx.closePath();
        },
        storeStroke(start, end, color, thickness) {
            this.unsentStrokes.push({
                start: start,
                end: end,
                color: color,
                thickness: thickness,
            });
        },
        drawDot(coordinates) {
            this.draw(coordinates, coordinates);
        },
        enableDraw(e) {
            this.setCoordinates(e);
            this.drawDot(this.currentCoordinates);
            this.canDraw = true;
        },
        disableDraw() {
            this.canDraw = false;
        },
        onDragStop(x, y) {
            this.setSignatureInfo({
                x: x,
                y: y,
                width: 200,
                height: 100,
            });
        },
    },
};
</script>

<style lang="scss" scoped>
.absolute-canvas {
    position: absolute;
    top: 0;
    left: 0;
    padding: 1rem;
    z-index: 10;
}

.signature {
    position: absolute;
    top: 0;
    left: 0;
    padding: 1rem;
    z-index: 20;
}
</style>